import classNames from "classnames";

import React, { MouseEventHandler, useState } from "react";

import SendDownloadLink from "components/SendDownloadLink";

import styles from "./HeroDownloadInfo.module.css";

const InstallViaHomebrew: React.FC = () => {
  const [tooltipText, setTooltipText] = useState("Copy code to clipboard");

  const handleCopy: MouseEventHandler = (event) => {
    event.preventDefault();

    navigator.clipboard.writeText("brew install --cask raycast");
    setTooltipText("Copied!");

    setTimeout(() => setTooltipText("Copy code to clipboard"), 2000);
  };

  return (
    <a href="#" onClick={handleCopy} className={styles.homebrewLink}>
      Install via Homebrew
      <span className={styles.brewTooltip}>{tooltipText}</span>
    </a>
  );
};

type PropTypes = {
  fadeInEnabled: boolean;
  transitionStarted: boolean;
  latestVersion: string;
};

const HeroDownloadInfo: React.FC<PropTypes> = ({ fadeInEnabled, transitionStarted, latestVersion }) => {
  const handleDownload: MouseEventHandler = (event) => {
    event.preventDefault();

    window.location.href = "https://api.raycast.app/v2/download";
  };

  return (
    <div
      className={classNames(styles.heroDownload, {
        [styles.fadeInEnabled]: fadeInEnabled,
        [styles.active]: transitionStarted,
      })}
    >
      <div className={styles.downloadLink}>
        <a href="#" onClick={handleDownload} className={styles.callToAction}>
          Download for Mac
        </a>
      </div>

      <div className={styles.sendDownloadInfoForm}>
        <SendDownloadLink />
      </div>

      <div className={styles.downloadInfo}>
        <span className={styles.version}>v{latestVersion}</span>
        <span className={styles.supportedMacVersion}>macOS 10.15+</span>
        <InstallViaHomebrew />
      </div>
    </div>
  );
};

export default HeroDownloadInfo;
